<template>
  <v-app>
    <v-app-bar>
      <v-avatar tile class="cursor-pointer" v-on:click="$router.push('/')">
        <img
          :style="{
            'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
            'max-height': '48px',
          }"
          aspect-ratio="1.0"
          :src="
            $operatorLogoUrl(user.domain)
          "
          :alt="domain"
        />
      </v-avatar>

      <v-toolbar-title class="ml-4 cursor-pointer"
        >{{ $t("registration") }}
      </v-toolbar-title>
    </v-app-bar>

    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <div class="mb-4 text-center" style="font-size:32px">
            {{ $t("trackYourBets") }}
          </div>

          <v-card class="elevation-0">
            <v-card-text class="px-6 pb-0">
              <v-form
                v-model="valid"
                ref="form"
                class="pt-4"
                autocomplete="off"
              >
                <v-text-field
                  v-model="user.name"
                  :label="$t('nameAndLastName')"
                  :rules="[rules.required, rules.max, rules.nameValid]"
                  name="nome"
                  prepend-icon="mdi-account"
                  outlined
                  clearable
                  type="text"
                ></v-text-field>

                <h3 class="px-0 pb-2 white--text">
                  {{ $t("accessCredential") }}
                </h3>
                <p class="pb-2">
                  {{ $t("UseYourPhoneToEnterOurWebsite") }}
                </p>
                <v-text-field
                  v-model="login"
                  :label="$t('logingYourPhone')"
                  name="login"
                  :hint="$t('validPhone')"
                  outlined
                  persistent-hint
                  required
                  readonly
                  disabled
                  prepend-icon="mdi-account-box"
                  class="mb-2"
                >
                  <template v-slot:append>
                    <v-icon color="green">mdi-check</v-icon>
                  </template>
                </v-text-field>
                <p class="pb-2">
                  {{ $t("createSecure8DigitPassword") }}
                </p>
                <v-text-field
                  :class="[show1 ? 'show-password' : 'hide-password']"
                  v-model="user.password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  type="text"
                  :label="$t('password')"
                  :hint="$t('hinitPassword')"
                  :rules="[
                    rules.required,
                    rules.passMin,
                    rules.passCaracter,
                    rules.max,
                  ]"
                  outlined
                  prepend-icon="mdi-lock"
                  @click:append="show1 = !show1"
                  required
                ></v-text-field>
                <v-text-field
                  :class="[show2 ? 'show-password' : 'hide-password']"
                  v-model="passwordConfirm"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  type="text"
                  :label="$t('confirmPassword')"
                  :rules="passMatch"
                  outlined
                  prepend-icon="mdi-lock"
                  @click:append="show2 = !show2"
                  required
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-6 pt-0 pb-12">
              <v-spacer></v-spacer>
              <v-btn
                x-large
                block
                :disabled="!valid"
                color="info"
                @click="onRegister"
                :loading="loading"
                >{{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card light>
        <v-card-text class="pa-6 mt-6 text-center">
          <div class="mb-0 text-center">
            <v-progress-circular
              v-if="!dialogIcon && !dialogErrorHandler"
              size="70"
              color="green"
              indeterminate
            ></v-progress-circular>
            <v-icon v-if="dialogIcon" size="70" color="green">{{
              icon
            }}</v-icon>
            <v-icon v-if="dialogErrorHandler" size="70" color="orange">{{
              icon
            }}</v-icon>

            <h3 class="mt-4 mb-2">{{ dialogMsg }}</h3>
            <v-progress-linear
              v-if="dialogIcon"
              color="green"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { validate } from "@/util/form-validate";
import qs from "qs"; // convert obj in "x-www-form-urlencoded format".

export default {
  name: "registerSms",
  data: () => ({
    show1: false,
    show2: false,
    valid: false,
    loading: false,
    dialog: false,

    dialogMsg: "Aguarde",
    dialogIcon: false,
    icon: "",
    dialogErrorHandler: false,

    login: null,
    user: {
      name: "",
      password: "",
      domain: "",
      hash: "",
      url_client: `${window.location.protocol}//${window.location.hostname}/`,
    },
    passwordConfirm: "",
    checkPasswordRules: {
      required: "Este campo é obrigatório.",
    },
    rules: {
      required: validate.required,
      nameValid: validate.nameValid,
      max: validate.max,
      passMin: validate.passMin,
      passCaracter: validate.passCaracter,
    },
  }),
  mounted() {
    this.user.hash = this.$route.query.hash;
    this.user.domain = this.$domain();

    // CONFIRMAR TELEFONE
    const data = {
      domain: this.$domain(),
      hash: this.$route.query.hash,
    };
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    this.$axios
      .put("player/register/confirmPhone", qs.stringify(data), headers)
      .then((resp) => {
        this.login = resp.data.dados;
        const msg = resp.data.messages;
        const color = "success";
        this.$store.commit("setNotification", { msg, color });
      });
    this.dialogMsg = this.$t("wait");
  },
  computed: {
    // Repet password
    passMatch() {
      const rules = [];
      // Required
      if (this.checkPasswordRules.required) {
        const rule = (v) => !!v || this.$t("requiredInput");
        rules.push(rule);
      }
      if (this.passwordConfirm) {
        const rule = (v) =>
          (!!v && v) === this.user.password || this.$t("repeatThePassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    // Register
    onRegister() {
      this.loading = true;
      this.dialog = true;
      const _this = this;

      if (this.$refs.form.validate()) {
        // 1. realiza o registro do usuário
        const register = (data) => {
          // reset:
          this.dialogErrorHandler = false;
          this.icon = "";

          const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
          };
          this.dialogMsg = "Aguarde. Estamos finalizando seu cadastro.";
          return new Promise((resolve, reject) => {
            this.$axios
              .put("player/register/confirmPlayer", qs.stringify(data), headers)
              .then((resp) => {
                if (this.login != null) {
                  resolve(resp);
                } else {
                  // const msg = "Cadastro Realizado com sucesso!";
                  // const color = "success";
                  this.$store.commit("setFeedback", {
                    title: this.$t("registrationBeenCompleted"),
                    msg: this.$t("successRegisterMsg"),
                    type: "",
                    action: "login",
                  });
                  this.$router.push("/");
                }
              })
              .catch((error) => {
                reject(error);
              })
              .finally(() => (this.loading = false));
          });
        };

        // 2. realiza o login do usuário
        const onLogin = () => {
          // ui
          this.dialogMsg =
            "Parabéns, cadastro realizado! Vamos realizar seu login.";
          this.icon = "mdi-check";
          this.dialogIcon = true;

          // login
          return this.$login(this.login, this.user.password);
        };

        // error
        const errorHandler = (error) => {
          // ui
          this.dialogIcon = false;
          this.dialogErrorHandler = true;
          this.icon = "mdi-alert";
          this.dialogMsg = error.response.data.messages;

          setTimeout(() => {
            _this.dialog = false; // close dialog
          }, 5000);
        };

        async function registerUser(data) {
          try {
            const result = await register(data); // 1.
            if (result.status == 201) {
              await onLogin(); // 2.
              setTimeout(() => {
                _this.$router.push("/");
              }, 3000);
            }
          } catch (error) {
            errorHandler(error); // 3.
          }
        }

        registerUser(this.user);
      } else {
        const msg = "Existe erro(s) no formulário, revise suas informações.";
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
        this.loading = false;
      }
    },

    // Notification Error Default
    // NotificationErrorDefaultNotificationErrorDefault(error) {
    //   const msg = error.response.data.messages[0];
    //   const color = "alert";
    //   this.$store.commit("setNotification", { msg, color });
    // }
  },
};
</script>
